// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
// RxJS
import { finalize, takeUntil, tap } from 'rxjs/operators';
// Translate
import { TranslateService } from '@ngx-translate/core';
// NGRX
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
// Auth
import { AuthNoticeService, AuthService, Register, User } from '../../../../core/auth/';
import { Subject } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthDialogComponent } from '../auth-dialog/auth-dialog.component'
import { EventEmitterService } from '../../shared/services/event-emitter.service';
import { DataTableService } from 'src/app/core/_base/layout';

@Component({
	selector: 'kt-register',
	templateUrl: './register.component.html',
	encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit, OnDestroy {
	registerForm: FormGroup;
	loading = false;
	errors: any = [];
	msgCode: number;

	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param authNoticeService: AuthNoticeService
	 * @param authDi
	 * @param translate: TranslateService
	 * @param router: Router
	 * @param auth: AuthService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 */
	constructor(
		private authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private router: Router,
		private auth: AuthService,
		private store: Store<AppState>,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private dialog: MatDialog,
		private eventEmitterService: EventEmitterService
	) {
		this.unsubscribe = new Subject();
	}

	/*
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
    */

	/**
	 * On init
	 */
	ngOnInit() {
		this.initRegisterForm();
	}

	/*
    * On destroy
    */
	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initRegisterForm() {
		this.registerForm = this.fb.group({
			firstName: ['', Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			])
			],
			lastName: ['', Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			]),
			],
			agree:['',Validators.compose([Validators.required, Validators.pattern('true')])],
			email: ['', Validators.compose([
				Validators.required,
				Validators.email,
				Validators.minLength(3),
				Validators.maxLength(320)
			]),
			],
		});
	}

	/**
	 * Form Submit
	 */
	submit() {
		const controls = this.registerForm.controls;

		// check form

		if (this.registerForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		this.loading = true;

		const _user: User = new User();
		_user.clear();
		_user.email = controls.email.value.trim();
		_user.firstName = controls.firstName.value.trim();
		_user.lastName = controls.lastName.value.trim();
		this.auth.register(_user).pipe(
			tap(user => {
				if (user) {
					if(user.statusCode == 200){
						this.store.dispatch(new Register({authToken: user.accessToken}));
						// pass notice message to the login page
						this.openDialog(_user, 1, 0); // 1 : success registration

						this.authNoticeService.setNotice(null);
						this.router.navigateByUrl('/auth/login');
					} else {
						//422
						if(user.statusCode == 422){
							this.openDialog(_user, 2, 0); // 1 : pending registration
							this.authNoticeService.setNotice(null);
						} else {
							this.authNoticeService.setNotice(user.message, 'info');
							this.router.navigateByUrl('/auth/register');
						}
					}
				} else {
					this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger');
					this.router.navigateByUrl('/auth/login');
				}
			}),
			takeUntil(this.unsubscribe),
			finalize(() => {
				this.loading = false;
				this.cdr.markForCheck();
			})
		).subscribe();
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.registerForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}


	openDialog(user: any, mcode: number, resendFlag: number): void {
		let dialogRef = this.dialog.open(AuthDialogComponent, {
		  width: '650px',
		  data: { name: user.firstName, email: user.email, code: mcode, resendFlag:resendFlag }
		});

		dialogRef.afterClosed().subscribe(result => {
			//console.log(result);
			if(result)
				this.reSendAuthentication(result,mcode);

			});
	  }

	  reSendAuthentication(user,mcode){

		console.log(user);
		this.auth.resendToken(user.email)
			.subscribe(
				(result)=>{
					//console.log(result);
					if(result.statusCode){
					//	this.authNoticeService.setNotice('Email sent successfully', 'success');
						var resendFlag=1;
						//this.router.navigateByUrl('/auth/login');
					//	console.log(user);
						this.openDialog(result['responseData'],mcode,resendFlag);
					}

			})
	  }

	  openDialog2(user, mcode, resendFlag): void {
		let dialogRef = this.dialog.open(AuthDialogComponent, {
		  width: '650px',
		  data: {name: user.name, email: user.email, code: mcode, resendFlag : resendFlag}
		});

		dialogRef.afterClosed().subscribe(result => {
			console.log(result);
			if(result)
				this.reSendAuthentication(result,mcode);
			});
	  }

}
